<div class="overflow-hidden rounded-lg border border-greyscale-200 bg-white">
  <button
    class="flex w-full items-center justify-between p-4 transition-colors hover:bg-primary-50/30"
    (click)="toggle()"
  >
    <div class="flex items-center gap-3">
      <div
        class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100"
      >
        <lucide-angular
          name="leaf"
          class="h-4 w-4 text-primary-600"
        ></lucide-angular>
      </div>
      <h3 class="text-lg font-semibold text-greyscale-900">Eco-Score</h3>
    </div>
    <span
      class="ml-auto mr-3 hidden text-paragraph-s-reg font-medium tabular-nums text-greyscale-800 sm:inline"
    >
      {{ ecoScoreService.getEcoScore(carbonIntensity) }}/10
    </span>
    <div
      class="text-greyscale-600 transition-transform duration-200"
      [class.rotate-90]="isOpen"
    >
      <lucide-angular name="chevronRight" class="h-5 w-5"></lucide-angular>
    </div>
  </button>

  @if (isOpen) {
    <div class="border-t border-greyscale-200 bg-primary-50 p-6">
      <div class="grid grid-cols-1 md:grid-cols-2">
        <app-intensity-gauge [carbonIntensity]="carbonIntensity" />
        <div class="flex flex-col justify-around text-justify">
          <div class="flex flex-row items-end">
            <h4 class="flex-1 text-greyscale-900">
              {{ "impactReport.ecoScore" | transloco }}
            </h4>
            <div class="flex-1">
              <p
                class="flex items-center rounded-full text-paragraph-reg text-greyscale-900"
              >
                {{ this.ecoScoreService.getEcoScore(carbonIntensity) }}/10
              </p>
            </div>
          </div>
          <div class="flex flex-row items-end">
            <h4 class="flex-1 text-greyscale-900">
              {{ "impactReport.carbonIntensity" | transloco }}
            </h4>

            <p class="flex-1 text-paragraph-med text-greyscale-900">
              <span>{{ displayedCarbonIntensity }}</span>
              {{ displayedUnit }}
            </p>
          </div>
          <p class="mt-3 pb-1 text-paragraph-s-reg text-greyscale-700">
            {{ "impactReport.carbonIntensityDescription" | transloco }}
          </p>
        </div>
      </div>
    </div>
  }
</div>
